import { useEffect, useRef } from 'react';
import { useGSAP } from '@gsap/react';
import { gsap } from 'gsap';

interface OptionsProps {
  shouldAnimate?: boolean;
}

export function Options({ shouldAnimate = false }: OptionsProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const timelineRef = useRef<GSAPTimeline>(null);

  useGSAP(() => {
    const mm = gsap.matchMedia();
    if (containerRef.current) {
      // Set initial state
      gsap.set(containerRef.current, {
        y: 20,
        opacity: 0,
      });

      mm.add('(min-width: 768px)', () => {
        // Create timeline but don't play it
        timelineRef.current = gsap
          .timeline({ paused: true, delay: 2 })
          .to(containerRef.current, {
            y: 0,
            opacity: 1,
            duration: 0.8,
          });
      });
    }
    mm.add('(max-width: 767px)', () => {
      timelineRef.current = gsap
        .timeline({ paused: true, delay: 0.7 })
        .to(containerRef.current, {
          y: 0,
          opacity: 1,
          duration: 0.8,
        });
    });
  }, []);

  useEffect(() => {
    if (shouldAnimate && timelineRef.current) {
      timelineRef.current.play();
    }
  }, [shouldAnimate]);
  return (
    <div
      ref={containerRef}
      className="m:max-w-290 s:max-w-[165px] min-[500px]:max-w-[200px] m:w-[40vw] mx-auto m:p-18 p-8 bg-cloud m:rounded-[15px] rounded-7 absolute m:top-60 l:top-60 xl:top-100 m:right-40 l:right-60 [min-width:1200px]:right-[80px] xl:right-[12%] right-15 bottom-15 shadow-[0_9.622px_45.946px_0.729px_rgba(48,46,122,0.09)] z-10 text-left h-max"
    >
      <div className="m:space-y-20 space-y-10">
        <div>
          <label className="block m:text-14 s:text-9 text-7 font-medium text-charcoal m:mb-8 mb-4">
            Name
          </label>
          <div className="m:h-30 s:h-25 h-15 w-full appearance-none rounded-5 m:border-2 border-1 border-grayscale-02 bg-cloud px-4 m:px-8 text-7 s:text-9 m:text-12 font-[500] leading-150 -tracking-1 flex items-center justify-between text-charcoal m:max-w-[190px] max-w-[90px] s:max-w-[100px]">
            Email Opt Out
          </div>
        </div>

        <div>
          <label className="block m:text-14 s:text-9 text-7 font-medium text-charcoal m:mb-8 mb-4">
            Purpose
          </label>
          <div className="m:h-30 s:h-25 h-15 w-full appearance-none rounded-5 m:border-2 border-1 border-grayscale-02 bg-cloud px-4 m:px-8 text-7 s:text-9 m:text-12 font-[500] leading-150 -tracking-1 flex items-center justify-between text-charcoal m:max-w-[190px] max-w-[90px] s:max-w-[100px]">
            Marketing
            <svg
              className="w-12 h-12 text-charcoal"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M6 9L12 15L18 9"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>

        <div>
          <label className="block m:text-14 s:text-9 text-7 font-medium text-charcoal m:mb-8 mb-4">
            Who does this workflow apply to?
          </label>
          <div className="m:h-30 s:h-25 h-15 w-full appearance-none rounded-5 m:border-2 border-1 border-grayscale-02 bg-cloud px-4 m:px-8 text-7 s:text-9 m:text-12 font-[500] leading-150 -tracking-1 flex items-center justify-between text-charcoal m:max-w-[190px] max-w-[90px] s:max-w-[100px]">
            Customer
            <svg
              className="w-12 h-12 text-charcoal"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M6 9L12 15L18 9"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
        <div>
          <div className="border-none w-max bg-electric-04 m:py-10 py-5 s:text-12 m:text-15 text-8 text-charcoal rounded-5 px-6 m:px-10 font-[440] mt-10">
            Add Consent Workflow
          </div>
        </div>
      </div>
    </div>
  );
}
